import actionTypes from '../../action-types'

export default (payload, history) => ({
  type: actionTypes.AUTHENTICATION.SET_SESSION_REQUEST,
  payload,
  history,
})
